import React from "react";
import TrekkingInfo from "../components/adventures/TrekkingInfo";

const Trekkings = () => {
  return (
    <section className="relative w-full min-h-screen text-white overflow-hidden">
       <TrekkingInfo />
    </section>
  );
};

export default Trekkings;
